import Http from '@/services/http';
import {
  DuvalMethod,
  NbrMethod,
  IecMethod,
  IeeeMethod,
} from 'sigma-mappings';
import msis127ErrorHandler from '@/domain/data/installation/engineering/cromaMSIS127ErrorHandler';
import { valuesToArray } from '@/services/objectHelpers';

const urls = {
  iec60599: (assetModuleId, sampleId) => `/engenharia/${assetModuleId}/cromatografia/amostras/${
    sampleId}/iec60599`,
  ieeec57104: (assetModuleId, sampleId) => `/engenharia/${assetModuleId}/cromatografia/amostras/${
    sampleId}/ieeec57104`,
  nbr7274: (assetModuleId, sampleId) => `/engenharia/${assetModuleId}/cromatografia/amostras/${
    sampleId}/nbr7274`,
  duval: (assetModuleId, sampleId) => `/engenharia/${assetModuleId}/cromatografia/amostras/${
    sampleId}/duval`,
};

/* istanbul ignore next */
const error = {
  ...msis127ErrorHandler,
};

/**
 * Implementação de serviço **privado**.
 * As implementações aqui foram feitas para serem consumidas pelo serviço principal da análise
 * individual.
 * @module RuleResults
 * @private
 */

/**
 * @private
 * Retorna os dados da norma IEC 60599.
 * @param {String} assetModuleId Id do módulo ativo.
 * @param {String} sampleId Id da amostra.
 * @returns {import('./index').RuleResultData[]} Array de resultados por método.
 */
export const getIec60599Result = (assetModuleId, sampleId) => new Http(error).get(
  urls.iec60599(assetModuleId, sampleId),
).then(({ data }) => valuesToArray(new IecMethod(data)))
.catch(error.msis127ErrorHandler);

/**
 * @private
 * Retorna os dados da norma NBR 7274.
 * @param {String} assetModuleId Id do módulo ativo.
 * @param {String} sampleId Id da amostra.
 * @returns {import('./index').RuleResultData[]} Array de resultados por método.
 */
export const getNbr7274Result = (assetModuleId, sampleId) => new Http(error).get(
  urls.nbr7274(assetModuleId, sampleId),
).then(({ data }) => valuesToArray(new NbrMethod(data)))
.catch(error.msis127ErrorHandler);

/**
 * @private
 * Retorna os dados da norma IEEE C57.104.
 * @param {String} assetModuleId Id do módulo ativo.
 * @param {String} sampleId Id da amostra.
 * @returns {import('./index').RuleResultData[]} Array de resultados por método.
 */
export const getIeeeC57104Result = (assetModuleId, sampleId) => new Http(error).get(
  urls.ieeec57104(assetModuleId, sampleId),
).then(({ data }) => valuesToArray(new IeeeMethod(data)))
.catch(error.msis127ErrorHandler);

/**
 * @private
 * Retorna os dados para os gráficos de Duval.
 * @param {String} assetModuleId Id do módulo ativo.
 * @param {String} sampleId Id da amostra.
 * @returns {import('./index').RuleResultData[]} Array de resultados por método.
 */
export const getDuvalResult = (assetModuleId, sampleId) => new Http(error).get(
  urls.duval(assetModuleId, sampleId),
).then(({ data }) => valuesToArray(new DuvalMethod(data)))
.catch(error.msis127ErrorHandler);
